import { PercentFormatter, StringUtil } from '@ddt-web/generic-utils';
import * as Highcharts from 'highcharts';
import * as isNil from 'lodash/isNil';

import { TooltipUtil } from './tooltip-util';

export class ProjectedGrowthTooltip {

	public static getFormatter(): any {
		return function (): string {
			const sortedPoints = TooltipUtil.getSortedPoints(this.points);
			let tooltipHtml = `<h4 class="tooltip-header text-12-bold">${Highcharts.dateFormat('%a, %b %e, %Y', this.x).toUpperCase()}</h4><table class="tooltip-table">`;

			// Get index of this point
			const pointIndex = this.points[0].point.index;

			sortedPoints.forEach((value) => {
				const medianPoint = value['median'];
				const rangePoint = value['range'];

				if (!isNil(medianPoint)) {
					const initialValue = medianPoint.series.yData[0];
					const valuesMap = TooltipUtil.getTooltipValues(rangePoint, medianPoint, pointIndex, initialValue, initialValue);
					tooltipHtml += ProjectedGrowthTooltip.getTooltipHtml(valuesMap);
				}
			});

			tooltipHtml += '</table>';
			return tooltipHtml;
		};
	}

	private static getTooltipHtml(valuesMap: Map<string, any>): string {
		const percentFormatter = (percentage) => isNaN(percentage) ? '-%' : (new PercentFormatter(1).format(percentage, true));
		const percentageClass = (percentage) => percentage >= 0 ? 'positive-percentage' : 'negative-percentage';
		const dollarFormatter = (value) => '$' + (value ? Highcharts.numberFormat(value, 0, '.', ',') : '-');

		return `<tr class="tooltip-header-row "><td colspan=3><div class="small-space"></div><span class="text-16" style="color:${StringUtil.escapeHtml(valuesMap.get('seriesColor'))}">\u25CF</span>&nbsp;&nbsp;`
			+ `${StringUtil.escapeHtml(valuesMap.get('seriesName'))}</td></tr>` +

			'<tr class="tooltip-row">' +
			'<td>Median</td>' +
			`<td class="text-12-bold">${dollarFormatter(valuesMap.get('median')?.medianPointData)}</td>` +
			`<td class="text-12-bold"><span class="${percentageClass(valuesMap.get('median')?.medianPercentageChange)}">${percentFormatter(valuesMap.get('median')?.medianPercentageChange)}</span></td>` +
			'</tr>' +

			'<tr class="tooltip-row">' +
			'<td>Low</td>' +
			`<td>${dollarFormatter(valuesMap.get('low')?.lowPointData)}</td>` +
			`<td><span class="${percentageClass(valuesMap.get('low')?.lowPercentageChange)}">${percentFormatter(valuesMap.get('low')?.lowPercentageChange)}</span></td>` +
			'</tr>' +

			'<tr class="tooltip-row">' +
			'<td>High</td>' +
			`<td>${dollarFormatter(valuesMap.get('high')?.highPointData)}</td>` +
			`<td><span class="${percentageClass(valuesMap.get('high')?.highPercentageChange)}">${percentFormatter(valuesMap.get('high')?.highPercentageChange)}</span></td>` +
			'</tr>';
	}
}
